import React from 'react';
import classnames from 'classnames';
import Icon from '../Icon/Icon';
import Spinner from '../Spinner/Spinner';
import Fade from '../Transitions/Fade/Fade';

import './Button.scss';

export interface ButtonProps {
    /**
     * Tag
     * @default 'button'
     */
    tag?: any;
    /**
     * Size button
     */
    size?: 'xs' | 'sm' | '';
    /**
     * Color style button
     */
    color?:
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'accent'
        | 'success'
        | 'warning'
        | 'error'
        | 'info'
        | 'none'
        | 'white';
    /**
     * Disabled attr
     */
    disabled?: boolean;
    /**
     * Outline button type
     */
    outline?: boolean;
    /**
     * Block content
     */
    block?: boolean;
    /**
     * Uppercase content
     */
    uppercase?: boolean;
    /**
     * Apply shadow in button
     */
    shadow?: boolean;
    /**
     *  Rounded border in button
     */
    rounded?: boolean;
    /**
     *  Show loader
     */
    loading?: boolean;
    /**
     *  Icon left
     */
    iconLeft?: string;
    /**
     *  Icon right
     */
    iconRight?: string;
    /**
     *  Icon size
     */
    iconSize?: number;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Function called on click button
     */
    onClick?(): any;
    /**
     * Slot component
     */
    children?: React.ReactNode;
    /**
     * Other props
     */
    [otherProps: string]: any;
}

const Button: React.FC<ButtonProps> = ({
    tag: Tag = 'button',
    size = '',
    color = 'primary',
    disabled = false,
    outline = false,
    block = false,
    uppercase = false,
    shadow = false,
    rounded = true,
    loading = false,
    iconLeft,
    iconRight,
    iconSize = 20,
    children,
    className,
    style = {},
    onClick = () => {},
    ...otherProps
}) => {
    const classNames = classnames([
        'button',
        color,
        size,
        {
            iconLeft,
            iconRight,
            disabled,
            outline,
            uppercase,
            shadow,
            rounded,
            block,
        },
        className,
    ]);

    return (
        <Tag disabled={disabled} className={classNames} style={style} onClick={onClick} {...otherProps}>
            <div className="button__wrapper">
                {loading && (
                    <Fade>
                        <Spinner color="white" size={15} className="button__loader" />
                    </Fade>
                )}
                {iconLeft ? <Icon name={iconLeft} size={iconSize} className="button__icon" /> : undefined}
                <span>{children}</span>
                {iconRight ? <Icon name={iconRight} size={iconSize} className="button__icon" /> : undefined}
            </div>
        </Tag>
    );
};

export default Button;
